<script>
    import * as api from './shared/api.js'
    import { dpo, account }  from './shared/stores.js'

    export let onLogoff

    function logout() {
        api.post('/user/logout').then(res => {
            if(res.status == 200){
                onLogoff(true)
                // $user.loggedIn = false
                // navigate('/')
            } else {
                onLogoff(false)
            }
        })
    }
</script>
<div class="menu">
    <span class="email">{$account.email}</span>
    {#if $dpo}
        <i class="id badge large purple icon"></i>
    {/if}
    <!-- <a alt="avisos">
        <i class="bell large white icon"></i>
    </a>
    <a alt="busca">
        <i class="search large white icon"></i>
    </a> -->
    <a alt="logoff" on:click={ logout }>
        <i class="power off large white icon"></i>
    </a>
</div>
<style>
    .menu {
        display : flex;
        justify-content: flex-end;
        margin  : 20px;
    }

    a {
        margin: 0 10px;
        color: white;
        cursor: pointer;
    }

    .email {
        color: white;
    }
</style>
